// @flow
import React, { Component } from "react";

import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import { BusinessCenter } from "@material-ui/icons";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import CreateButton from "../CreateButton";
import CompanyInfo from "./CompanyInfo";
import { buildCompanyFormJson } from "./CompileCompanytoJson";
import { GeneralModalForm } from "imagus-components";
import CreateCompanyFormRedux from "../../containers/companies/CreateCompanyFormRedux";

type AccountCompanyStatesType = {
  modalOpen: boolean
};

class AccountCompany extends Component<*, AccountCompanyStatesType> {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  };

  render(): React$Element<*> {
    const company = this.props.company;
    if (company) {
      const companyFormData = buildCompanyFormJson(company);
      return (
        <div className="app-panel-content">
          <Grid container spacing={24}>
            <Grid item xs={12} md={3}>
              <div className="avatar-block">
                <Avatar alt="Company Image" className="avatar-img">
                  <BusinessCenter className="avatar-icon" />
                </Avatar>
              </div>
            </Grid>
            <Grid item xs={12} md={9}>
              <CompanyInfo
                company={company}
                tableStyle={{ maxWidth: "800px" }}
                isEditable
                editCompany={(): * => this.switchModalStatus(true)}
              />
              <GeneralModalForm
                title={"Edit for " + company.name}
                open={this.state.modalOpen}
                handleModalStatus={this.switchModalStatus}
                form={
                  <CreateCompanyFormRedux
                    onClose={(): * => this.switchModalStatus(false)}
                    company={company}
                    openSnackbar={this.props.openSnackbar}
                    isEdit
                  />
                }
              />
              {this.props.canEdit && (
                <div style={{ width: "100%", maxWidth: "800px" }}>
                  <CreateButton
                    title="Create System"
                    theme="light"
                    iconName="GroupWorkIcon"
                    formName="CreateFacebaseFormRedux"
                    modal="facebase-modal"
                    company={companyFormData}
                    openSnackbar={this.props.openSnackbar}
                    iconOnly
                    className="left-margin-20 right-margin-30"
                  />
                  <CreateButton
                    title="Create Company"
                    theme="dark"
                    iconName="FiberNewIcon"
                    formName="CreateCompanyFormRedux"
                    modal="company-modal"
                    company={companyFormData}
                    openSnackbar={this.props.openSnackbar}
                    className="right-margin-30"
                  />
                  <CreateButton
                    title="Create User"
                    theme="light"
                    iconName="PersonAddIcon"
                    formName="CreateUserFormRedux"
                    modal="user-modal"
                    company={companyFormData}
                    facebases={this.props.facebases}
                    openSnackbar={this.props.openSnackbar}
                    iconOnly
                    className="right-margin-30"
                  />
                  <CreateButton
                    title="Create Licence"
                    theme="dark"
                    iconName="NoteAddIcon"
                    formName="CreateLicenceFormRedux"
                    modal="licence-modal"
                    company={companyFormData}
                    facebases={this.props.facebases}
                    openSnackbar={this.props.openSnackbar}
                  />
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default AccountCompany;
